import Cookies from "js-cookie";
import Pusher from 'pusher-js';
import {sessionStore} from "./sessionStore";

class PusherClient {
    constructor() {
        const token = sessionStore.get("token") ?? (Cookies.get("_f") ? JSON.parse(Cookies.get("_f").toString()) : null);

        if(token) {
            this.pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
                cluster: "eu",
                forceTLS: true,
                authEndpoint: (new URL( '/pusher/auth', process.env.REACT_APP_API_ENTRYPOINT)).href,
                auth: {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            });

            this.subscribe = this.subscribe.bind(this);
        }
    }

    subscribe(channelName) {
        return this.pusher.subscribe('private-' + channelName);
    }
    unbind(eventName) {
        return this.pusher.unbind(eventName)
    }

    unsubscribe(channelName) {
        return this.pusher.unsubscribe(channelName)
    }
}
const pusherClient = new PusherClient();

export default pusherClient;
